import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Form } from "react-bootstrap";
import LicensePlateChangeViewModel from "../../../../viewModels/notice/licensePlateChange/licensePlateChangeViewModel";
import CountryIdInput from "../../../common/countryIdInput/countryIdInput";
import LicensePlateInput from "../../../common/licensePlateInput/licensePlateInput";

const LicensePlateChangeNotice: FunctionComponent<{
  vm: LicensePlateChangeViewModel;
}> = observer(({ vm }) => {
  const translate = (translateKey?: string) => (code: string) =>
    vm.localizationService.translateAttribute(translateKey ? `orderItem.${translateKey}` : "orderItem", code);

  return (
    <>
      <div>
        <h1 className="mb-0 h3">{vm.translateGeneral("title")}</h1>
        <span>{vm.translateGeneral("reason")}</span>
      </div>
      <div className="mt-4">
        <>
          <Form.Row className="align-items-baseline">
            <CountryIdInput vm={vm.originalVehicleInfoViewModel} translateKey={"old"} />
            <CountryIdInput
              vm={vm.newVehicleInfoViewModel}
              translateKey={"new"}
              errorMessage={vm.newVehicleErrorMessage}
              labelId={"new-vehicle-country-label"}
            />
          </Form.Row>
          <Form.Row className="align-items-baseline">
            <LicensePlateInput
              id="notice-vehicle-license-plate-input"
              target={vm.notice.vehicle}
              property="licensePlate"
              countryCode={vm.originalVehicleInfoViewModel.countryCode}
              countryId={vm.notice.vehicle?.countryId}
              translate={translate("old")}
              locale={vm.localizationService.locale}
            />
            <LicensePlateInput
              id="notice-license-plate-input"
              target={vm.notice}
              property="licensePlate"
              errorMessage={vm.newVehicleErrorMessage}
              countryCode={vm.newVehicleInfoViewModel.countryCode}
              countryId={vm.notice.countryId}
              translate={translate("new")}
              locale={vm.localizationService.locale}
            />
          </Form.Row>
        </>
      </div>
    </>
  );
});

export default LicensePlateChangeNotice;
